import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { getDisplayNameOfAddress } from "owa-mail-proxy-address/lib/utils/getDisplayNameOfAddress";
import { isConsumer } from "owa-session-store";

export function resolveMemberName(email: string, mailboxInfo: MailboxInfo): string {
    if (isConsumer() && isGlobalFeatureEnabled("acct-fixDisplayNameForMsa")) {
        const displayNameForMsa = getDisplayNameOfAddress(email, mailboxInfo);
        if (displayNameForMsa) {
            return displayNameForMsa;
        }
    }
    return email;
}
